import GeneralForms from './generalForms';
import Cameras from './cameras';
import Devices from './devices';
import Communications from './Communications';
import Note from './Note';
import Notification from './Notification';
import PanelUser from './PanelUser';
import PanelUserLDAP from './PanelUserLDAP';
import Exceptions from './exceptions';
import Zone from './zoneForms';
import RemoteUser from './remoteUser';
import Vacation from './vacation';
import WorkHours from './workhours';
import WorkHoursTolerance from './workhoursTolerance';





export default {
    GeneralForms, Cameras, Devices, Communications, Note, Notification, PanelUser, 
    Exceptions, Zone, RemoteUser, Vacation, WorkHours, WorkHoursTolerance, PanelUserLDAP
}


// WEBPACK FOOTER //
// ./src/pages/Alarmsis/Account/forms/index.js